/* global setTimeout */
import $ from 'jquery';

$(document)
.on('click', '.static_grid_icon', e => {
    const $el = $(e.currentTarget);
    $el.parent().siblings('.active').removeClass('active');
    $el.parent().toggleClass('active');
    e.stopPropagation();
})
.on('click', '.modal_close', e => {
    $(e.currentTarget)
    .closest('.modal')
    .addClass('modal-closing');
    setTimeout(function() {
        $('.modal').remove();
    }, 1000);
});

const closeModal = function() {
    setTimeout(function() {
        $('.modal').remove();
    }, 3100);
};

export default closeModal;



// WEBPACK FOOTER //
// ./scripts/modal.js